module.exports = __webpack_public_path__ + "static/media/space-listing.2f491f3d.jpg";